export default __webpack_public_path__ + "static/media/livetv-medium.8ae80cd0.jpg";